import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { formatDate, getDateFromSap } from '@core/utils';

interface IFeriasCardProps {
    path: any;
    inicioPeriodo: string;
    fimPeriodo: string;
    diasFerias: number;
    status: string;
}

const gridStyles = {
    marginTop: '0.5rem',
    cursor: 'pointer',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: '#fff',
    display: 'flex',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    width: '100%',
    borderRadius: '8px',
    padding: '1.5rem'
};

const textStyle = {
    fontSize: '0.8rem',
    lineHeight: 1
};

const buildDetalhesPeriodoUrl = (path: string, inicioPeriodo: string, fimPeriodo: string) => {
    return path.replace(':inicioPeriodo', inicioPeriodo).replace(':fimPeriodo', fimPeriodo);
};

export const FeriasCard: React.FC<IFeriasCardProps> = ({ path, inicioPeriodo, fimPeriodo, diasFerias, status }) => {
    const navigate = useNavigate();
    const feriasQuitadas = 30 - Number(diasFerias);

    return (
        <Grid item xs={12} onClick={() => navigate(buildDetalhesPeriodoUrl(path, inicioPeriodo, fimPeriodo))} sx={{ ...gridStyles }}>
            <Grid sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <Typography sx={{ ...textStyle, fontWeight: 'bold' }}>
                    {formatDate(getDateFromSap(inicioPeriodo), false)} até {formatDate(getDateFromSap(fimPeriodo), false)}
                </Typography>
                {status === 'Aberto' ? (
                    <Typography sx={{ ...textStyle, marginTop: '1rem' }}>Saldo: {diasFerias} dias</Typography>
                ) : (
                    <Typography sx={{ ...textStyle, marginTop: '1rem' }}>{feriasQuitadas} dias de férias sem abono</Typography>
                )}
            </Grid>
            <ChevronRight />
        </Grid>
    );
};
